import { buildSearchEngine, getOrganizationEndpoints, SearchEngine } from '@coveo/headless';
import isCoveoAnalyticsEnabled from '../isCoveoAnalyticsEnabled';

const orgId = process.env.NEXT_PUBLIC_COVEO_ORG_ID || 'iqviafnaquintilesimsnonproduction12c6jth8d';

// eslint-disable-next-line @typescript-eslint/ban-types
const sitesHeadlessEngine: SearchEngine<{}> = buildSearchEngine({
  configuration: {
    organizationId: orgId,
    accessToken:
      process.env.NEXT_PUBLIC_COVEO_SITES_ACCESSTOKEN || 'xx7f5138ce-1ddd-4e63-a922-0730d9795d4b',
    organizationEndpoints: getOrganizationEndpoints(orgId),
    search: {
      searchHub: process.env.NEXT_PUBLIC_COVEO_SITES_SEARCHHUB || 'AvacareProtocolSitesDev',
    },
    analytics: {
      enabled: isCoveoAnalyticsEnabled(),
      originLevel3: '/locations',
    },
  },
});

export default sitesHeadlessEngine;
